import React from 'react';

import { Select } from '@jobandtalent/design-system';

import type useBulkAssignments from './useBulkAssignments';
import type { BulkAssignmentOption } from './useBulkAssignments';

type BulkAssignmentSelectProps = {
  options: BulkAssignmentOption[];
  shareResourceIds?: boolean;
  assignments: ReturnType<typeof useBulkAssignments>;
};

const BulkAssignmentSelect = ({ options, assignments, shareResourceIds = false }: BulkAssignmentSelectProps) => (
  <>
    <Select
      isMulti
      closeMenuOnSelect={false}
      isDisabled={assignments.isSaving}
      value={assignments.selected}
      onChange={(selected: readonly BulkAssignmentOption[] | null) => assignments.setSelected([...(selected || [])])}
      options={options.filter((option) => !assignments.completedIds.has(option.value))}
      placeholder="Select items to add…"
    />
    <p>{shareResourceIds ? "The data scopes, resource IDs, and reason below apply to every selected item." : "The data scopes and reason below apply to every selected item."}</p>
    {assignments.progress && (
      <p role="status">{assignments.progress.added} added. {assignments.progress.failed} failed.</p>
    )}
    {assignments.failures.length > 0 && (
      <div role="alert">
        <p>Only the failed items remain selected. Save again to retry.</p>
        <ul>
          {assignments.failures.map((failure) => <li key={failure.id}>{failure.label}: {failure.message}</li>)}
        </ul>
      </div>
    )}
  </>
);

export default BulkAssignmentSelect;
